/* =========================================================
* react-selectでidを更新する時の処理を共通化
* valueのみをセットできるようにする
* @params selected_option 選択されたoption
* @params setId setId系のイベントハンドラ（eg. setAreaIds）
========================================================= */
export const handleChangeId = (selected_option, setId) => {
  setId(selected_option.value);
}